export function AdSlot({ format = "leaderboard", className = "" }) {
  // Reserved, layout-shift-safe ad container. No real ads until AdSense is added.
  const sizes = {
    leaderboard: "h-[90px] max-w-[728px]",
    rectangle: "h-[250px] max-w-[300px]",
    banner: "h-[100px] max-w-full",
  };
  return (
    <div
      className={`mx-auto w-full ${sizes[format]} ${className}`}
      data-testid={`ad-slot-${format}`}
      aria-hidden="true"
    >
      <div className="flex h-full w-full items-center justify-center rounded-md border border-dashed border-border bg-muted/30">
        <span className="text-[10px] font-medium uppercase tracking-[0.25em] text-muted-foreground/60">
          Advertisement
        </span>
      </div>
    </div>
  );
}
